<template>
    <collapsible-card :title="'Utilization for the Last 30 Days'" v-show="showChart" ref="cCard">
        <div class="cardContent chartContent">
            <div class="chart">
                <div id="utilChart" v-show="showChart"></div>
            </div>
        </div>
    </collapsible-card>
</template>

<script>
import Highcharts from 'highcharts';
import { formatMinutes } from '../../helpers/Formatting.js';
import CollapsibleCard from '../CollapsibleCard';

export default {
    name: "vessel-chart-utilization",
    components: {
        CollapsibleCard
    },
    data: () => ({
        showChart: false,
    }),
    methods: {
        createChart: function(utilizationData) {
            var globv = this;
            globv.showChart = false;
            if (utilizationData && (utilizationData['site'] || utilizationData['transit'] || utilizationData['port'])) {
                let data = [
                    {
                        name: "On Site",
                        y: utilizationData['site'],
                        custom: {}
                    },
                    {
                        name: "In Transit",
                        y: utilizationData['transit'],
                        custom: {}
                    },
                    {
                        name: "At Port",
                        y: utilizationData['port'],
                        custom: {}
                    }
                ]
                let totalMin = data.reduce((total, curr) => total + curr['y'], 0);

                for (let d in data) {
                    data[d]['custom']['percentage'] = (data[d]['y'] / totalMin * 100).toFixed(2) + '%'
                    data[d]['custom']['time'] = formatMinutes(data[d]['y']);
                }

                Highcharts.theme = {
                    colors: [
                        "#6DDF76",
                        "#F9C74F",
                        "#409BC9",
                    ]
                }

                Highcharts.setOptions(Highcharts.theme);

                Highcharts.chart('utilChart', {
                    chart: {
                        type: 'pie',
                        backgroundColor: '#22293d'
                    },
                    credits: {
                        enabled: false,
                        credits: false
                    },
                    title: {
                        text: null
                    },
                    tooltip: {
                        pointFormat:
                            'Percentage: {point.options.custom.percentage} <br/>' + 
                            'Time: {point.options.custom.time}'
                    },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                enabled: false,
                            },
                            showInLegend: true
                        }
                    },
                    legend: {
                        itemStyle: {
                            color: "#fff"
                        },
                        labelFormatter: function() {
                            return this.name + ": " + this.options.custom.time;
                        }
                    },
                    series: [{
                        name: 'Utility',
                        data: data
                    }]
                });

                globv.showChart = true;
                globv.$refs.cCard.adjustHeight();
            }
        },
        reset: function() {
            var globv = this;
            globv.showChart = false;
        }
    }
}
</script>